// ================================================================
// src/freeStudy/PaymentReturn.jsx
// صفحه‌ی بازگشت از درگاه زرین‌پال
// ================================================================
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { parseCallbackParams } from '../services/paymentService.js';
import {
  completePendingPurchase,
  getPendingPurchase,
} from './purchase.js';

export default function PaymentReturn() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [status, setStatus] = useState('processing');
  const [message, setMessage] = useState('در حال تأیید پرداخت...');

  useEffect(() => {
    if (!user?.id) {
      setStatus('error');
      setMessage('برای بررسی پرداخت ابتدا وارد شوید');
      setTimeout(() => navigate('/login', { replace: true }), 1500);
      return;
    }

    let mounted = true;

    (async () => {
      try {
        const cb = parseCallbackParams();
        const pending = await getPendingPurchase(user.id);

        // اگر پارامترها ناقص‌اند ولی pending داریم، به صفحه‌ی دوره برگردان
        if (!cb.paymentId || !cb.authority) {
          if (pending?.courseId) {
            navigate(`/free-study/${pending.courseId}`, { replace: true });
          } else {
            if (!mounted) return;
            setStatus('error');
            setMessage('پارامترهای بازگشتی از درگاه ناقص است');
          }
          return;
        }

        const res = await completePendingPurchase({
          userId: user.id,
          callback: cb,
        });
        if (!mounted) return;

        if (res.ok && res.courseId) {
          setStatus('success');
          setMessage(`پرداخت موفق — کد پیگیری: ${res.refId}`);
          setTimeout(() => {
            navigate(`/free-study/${res.courseId}?payment=success`, {
              replace: true,
            });
          }, 1500);
        } else {
          setStatus('error');
          setMessage(res.message || 'پرداخت ناموفق بود');
          const p = await getPendingPurchase(user.id);
          if (p?.courseId) {
            setTimeout(() => {
              navigate(`/free-study/${p.courseId}?payment=failed`, {
                replace: true,
              });
            }, 2500);
          }
        }
      } catch (e) {
        if (!mounted) return;
        setStatus('error');
        setMessage(e.message || 'خطای غیرمنتظره در تأیید پرداخت');
      }
    })();

    return () => {
      mounted = false;
    };
  }, [user, navigate]);

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        padding: 24,
        textAlign: 'center',
        direction: 'rtl',
        fontFamily: 'inherit',
      }}
    >
      <div style={{ maxWidth: 420 }}>
        {status === 'processing' && (
          <>
            <div
              style={{
                width: 64,
                height: 64,
                margin: '0 auto 20px',
                border: '4px solid #e5e7eb',
                borderTopColor: '#4f46e5',
                borderRadius: '50%',
                animation: 'pr-spin 0.8s linear infinite',
              }}
            />
            <style>{`@keyframes pr-spin { to { transform: rotate(360deg); } }`}</style>
            <h2 style={{ marginBottom: 8 }}>در حال تأیید پرداخت</h2>
            <p style={{ color: '#64748b' }}>{message}</p>
          </>
        )}

        {status === 'success' && (
          <>
            <div style={{ fontSize: 64, marginBottom: 12 }}>✅</div>
            <h2 style={{ marginBottom: 8, color: '#16a34a' }}>پرداخت موفق</h2>
            <p style={{ color: '#64748b' }}>{message}</p>
            <p style={{ fontSize: 13, color: '#94a3b8' }}>
              در حال انتقال به صفحه‌ی دوره...
            </p>
          </>
        )}

        {status === 'error' && (
          <>
            <div style={{ fontSize: 64, marginBottom: 12 }}>❌</div>
            <h2 style={{ marginBottom: 8, color: '#dc2626' }}>پرداخت ناموفق</h2>
            <p style={{ color: '#64748b' }}>{message}</p>
          </>
        )}
      </div>
    </div>
  );
}